import React, { Component } from "react";
import PropTypes from "prop-types";

import { flow, get, keyBy, map, mapValues, noop, partialRight } from "lodash";

import RatingList from "../RatingList";
import styles from "./RatingGrid.module.css";

import Header from "./components/Header";
import { createOplogEntry } from "../../utils/oplogHelpers";
import { generateGroupItem, generateOptionItem } from "../../utils/context";

class RatingGrid extends Component {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      groups: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          text: PropTypes.string.isRequired,
        })
      ).isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          text: PropTypes.string.isRequired,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            .isRequired,
        })
      ).isRequired,
      value: PropTypes.object,
      duration: PropTypes.number.isRequired,
      // Discarded questions generated by this question
      discarded: PropTypes.array,
      custom: PropTypes.objectOf(
        PropTypes.shape({
          name: PropTypes.string,
          text: PropTypes.string
        })
      ),
      onInit: PropTypes.func,
      onChange: PropTypes.func
    };
  }

  static get defaultProps() {
    return {
      value: {},
      discarded: [],
      custom: null,
      onInit: noop,
      onChange: noop
    };
  }

  constructor(props) {
    super(props);

    const formatValue = flow([
      partialRight(keyBy, "name"),
      partialRight(mapValues, (option, key) =>
        get(props.value, key, {
          value: null
        })
      )
    ]);

    this.state = {
      value: formatValue(props.groups)
    };

    this.handleChange = this.handleChange.bind(this);
  }

  UNSAFE_componentWillMount () {
    // Pass state and answer to parent (Question) component right before being appended to DOM
    this.props.onInit(
      this.props.name,
      this.props.type,
      {
        groups: map(this.props.groups, generateGroupItem),
        options: map(this.props.options, generateOptionItem),
        discarded: this.props.discarded,
        custom: this.props.custom
      },
      this.props.value,
      this.props.duration
    );
  }

  componentDidMount() {
    this.props.doOplogUpdate(createOplogEntry(this.props.name, "in"))
  }

  componentWillUnmount() {
    this.props.doOplogUpdate(createOplogEntry(this.props.name, "out"));
  }

  handleChange(e, group, rating) {
    const state = this.state;
    state.value[group.name].value = rating;
    this.setState(state);

    this.props.onChange(e, state.value);
  }

  render() {
    return (
      <div className={styles.container}>
        {this.props.groups.map((group, groupIdx) => (
          <div className={styles.group} key={group.name}>
            <Header>{group.text}</Header>
            <RatingList
              name={group.name}
              type={this.props.type}
              options={this.props.options}
              value={this.state.value[group.name].value}
              duration={this.props.duration}
              custom={this.props.custom}
              onChange={(e, rating) => this.handleChange(e, group, rating)}
              parentName={this.props.name}
              groupIdx={groupIdx}
              doOplogUpdate={this.props.doOplogUpdate}
            />
          </div>
        ))}
      </div>
    );
  }
}

export default RatingGrid;
